import * as $ from "jquery";
import * as _ from "lodash";
import { PermissionCollection } from "../../collections/Permissions";
import { UserGroupCollection } from "../../collections/UserGroups";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "./_BaseModifyModal";

require("bootstrap-toggle");
var template = require("templates/modals/addInstall.html");
var modalId = "addInstallModal";

interface AddInstallModalOptions extends BaseModifyModalViewOptions {
    org: Backbone.Model;
}

export class AddInstallModal extends BaseModifyModalView {
    public options: AddInstallModalOptions;
    private permissionCollectionLoaded = false;
    private template = _.template(template);

    constructor(options: AddInstallModalOptions) {
        super(
            <any>_.extend({}, options, {
                tagName: "div",
                events: {
                    "shown.bs.modal #addInstallModal": "handleModalShown",
                    "hidden.bs.modal #addInstallModal": "handleModalHidden",
                    "change .add-install-modal-org-select": "handleOrgChange",
                    "input .add-install-modal-install-sn": "handleInstallSNChange",
                    "input .add-install-modal-install-name": "handleInstallNameChange",
                    "change .permission-checkbox": "handlePermissionChange",
                    "click .add-install-modal-install-submit": "handleAddInstallButtonClick",
                },
            })
        );

        // For the base class methods
        this.modalIdSelector = modalId;
    }

    render() {
        this.$el.html(
            this.template({
                elementId: modalId,
                organizationCollection: this.options.organizationCollection,
                permissionCollection: this.options.permissionCollection,
                orgID: this.options.org.get("id"),
            })
        );
        return this;
    }

    show() {
        (<any>this.$("#" + modalId)).modal("show");
        this.handleOrgChange();
    }

    handleOrgChange() {
        this.permissionCollectionLoaded = false;
        this.$(".permissions-loading").removeClass("hidden");
        this.$(".permissions-loaded").addClass("hidden");

        var orgId = this.getOrgId();
        this.userGroupPermissionsCollections = {};
        this.userGroupCollection = new UserGroupCollection([], { organizationId: orgId });

        var permissionsCollectionDeferreds = [];
        this.userGroupCollection.on("sync", () => {
            this.userGroupCollection.each((g) => {
                var id = g.get("id");

                this.userGroupPermissionsCollections[id] = new PermissionCollection([], { userGroupId: id });
                var d = $.Deferred();
                permissionsCollectionDeferreds.push(d);
                this.userGroupPermissionsCollections[id].on("sync", d.resolve, this);
                this.userGroupPermissionsCollections[id].fetch();
            }, this);

            $.when.apply($, permissionsCollectionDeferreds).done(() => {
                this.handlePermissionsCollectionLoaded();
            });
        });
        this.userGroupCollection.fetch({ reset: true });

        // Re-evaluate the install sn, in case it's part of the org
        this.handleInstallSNChange();
        this.setSubmitButtonEnabledState();
    }

    handlePermissionsCollectionLoaded() {
        this.$(".permissions-loading").addClass("hidden");
        this.$(".permissions-loaded").removeClass("hidden");

        var installRows = [];
        var controlRows = [];

        this.userGroupCollection.each((group) => {
            var id = group.get("id");
            if (!this.options.permissionCollection.canModifyUserGroupPermissions(id)) return;

            var isAdmin = group.get("is_admin") || this.userGroupCollection.length === 1;

            installRows.push(
                '<tr class="permission-row" data-permission="install" data-id="' +
                    id +
                    '">' +
                    "<td>" +
                    group.get("name") +
                    "</td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-1" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    '<td class="text-center hidden"><input type="checkbox" class="permission-checkbox permission-checkbox-2" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-3" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-4" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    "</tr>"
            );
            controlRows.push(
                '<tr class="permission-row" data-permission="control" data-id="' +
                    id +
                    '">' +
                    "<td>" +
                    group.get("name") +
                    "</td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-1" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-2" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-3" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    '<td class="text-center"><input type="checkbox" class="permission-checkbox permission-checkbox-4" data-toggle="toggle" data-on="Yes" data-off="No" data-size="mini" ' +
                    (isAdmin ? " checked disabled" : "") +
                    "></td>" +
                    "</tr>"
            );
        });

        this.permissionCollectionLoaded = true;
        if (!installRows.length) {
            var message =
                '<tr class="danger text-danger text-center">' +
                '<td colspan="5">' +
                "You may not grant permission to any team in this organization. <br>" +
                "Since the new installation would be inaccessible to you, you may not create a installation for this organization" +
                "</td>" +
                "</tr>";
            installRows.push(message);
            controlRows.push(message);
        }

        this.$('.permissions-loaded table[data-permission="install"] tbody').html(installRows.join(""));
        this.$('.permissions-loaded table[data-permission="controls"] tbody').html(controlRows.join(""));
        (<any>this.$('.permissions-loaded input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();

        setTimeout(() => {
            this.setSubmitButtonEnabledState();
        }, 300);
    }

    handlePermissionChange(e: JQuery.UIEventBase) {
        var checkbox = $(e.currentTarget);
        var checked = checkbox.is(":checked");

        var parentRow = checkbox.parents(".permission-row");
        var c1 = parentRow.find(".permission-checkbox-1");
        var c2 = parentRow.find(".permission-checkbox-2");
        var c3 = parentRow.find(".permission-checkbox-3");
        var c4 = parentRow.find(".permission-checkbox-4");

        var section = parentRow.attr("data-permission");
        var id = parentRow.attr("data-id");
        switch (section) {
            case "install":
                if (checked) {
                    if (checkbox.is(c2)) {
                        c1.prop("checked", true).change();
                    } else if (checkbox.is(c3)) {
                        c1.prop("checked", true).change();
                    } else if (checkbox.is(c4)) {
                        c1.prop("checked", true).change();
                        c3.prop("checked", true).change();
                    }
                } else {
                    if (checkbox.is(c1)) {
                        c2.prop("checked", false).change();
                        c3.prop("checked", false).change();
                        c4.prop("checked", false).change();

                        // If we're not allowed to view, we're not allowed to control
                        this.$('.permission-row[data-permission="control"][data-id="' + id + '"] .permission-checkbox')
                            .prop("checked", false)
                            .change();
                    } else if (checkbox.is(c3)) {
                        c4.prop("checked", false).change();

                        // If we're not allowed to view the settings, we're not allowed to view the control settings
                        this.$(
                            '.permission-row[data-permission="control"][data-id="' + id + '"] .permission-checkbox-1'
                        )
                            .prop("checked", false)
                            .change();
                    }
                }
                break;
            case "control":
                if (checked) {
                    if (checkbox.is(c2)) {
                        c1.prop("checked", true).change();
                    } else if (checkbox.is(c4)) {
                        c3.prop("checked", true).change();
                    }

                    // To view the control settings, we must be able to view the settings
                    if (checkbox.is(c1)) {
                        this.$(
                            '.permission-row[data-permission="install"][data-id="' + id + '"] .permission-checkbox-3'
                        )
                            .prop("checked", true)
                            .change();
                    }

                    // To control, we must be allowed to view the install
                    this.$('.permission-row[data-permission="install"][data-id="' + id + '"] .permission-checkbox-1')
                        .prop("checked", true)
                        .change();
                } else {
                    // To control, we must be allowed to view the install
                    if (checkbox.is(c1)) {
                        c2.prop("checked", false).change();
                    } else if (checkbox.is(c3)) {
                        c4.prop("checked", false).change();
                    }
                }
                break;
        }
    }

    getOrgId() {
        return Number(this.$(".add-install-modal-org-select").val());
    }

    getName() {
        return (<string>this.$(".add-install-modal-install-name").val()).trim();
    }

    getSN() {
        return (<string>this.$(".add-install-modal-install-sn").val()).toUpperCase().trim();
    }

    getInstallId() {
        return this.options.installCollection.findWhere({ name: this.getSN() }).get("id");
    }

    handleInstallSNChange() {
        var formGroup = this.$(".add-install-modal-install-sn").parents(".form-group");
        var organizationId = this.getOrgId();

        var value = this.getSN();
        if (!value.length) return;
        console.log(this.options.installCollection);
        var orgInstalls = this.options.installCollection.where({ name: value });
        if (orgInstalls.length) {
            var installPartOfOrg = false;
            _.each(orgInstalls, (org) => {
                if (org.get("organization_id") === organizationId) installPartOfOrg = true;
            });

            if (installPartOfOrg) {
                formGroup.addClass("has-error");
                formGroup.removeClass("has-success");
            } else {
                formGroup.addClass("has-success");
                formGroup.removeClass("has-error");
            }
        } else {
            formGroup.removeClass("has-success");
            formGroup.addClass("has-error");
        }

        this.setSubmitButtonEnabledState();
    }

    handleInstallNameChange() {
        var formGroup = this.$(".add-install-modal-install-name").parents(".form-group");
        var value = this.getName();
        if (!value.length) {
            formGroup.addClass("has-error");
            formGroup.removeClass("has-success");
        } else {
            formGroup.addClass("has-success");
            formGroup.removeClass("has-error");
        }

        this.setSubmitButtonEnabledState();
    }

    setSubmitButtonEnabledState() {
        var errors = this.$(".has-error");
        this.$(".add-install-modal-install-submit").prop(
            "disabled",
            !this.getSN().length || !this.getName().length || errors.length || !this.permissionCollectionLoaded
        );
    }

    getPermissionsDict() {
        var installId = this.getInstallId();
        var permissions = {};

        _.each(this.$('.permissions-loaded .permission-row[data-permission="install"]'), (groupRow) => {
            var id = $(groupRow).attr("data-id");
            if (!_.has(permissions, id)) permissions[id] = [];

            if ($(groupRow).find(".permission-checkbox-1").is(":checked")) {
                permissions[id].push("install:" + installId + ":view", "install:" + installId + ":ss:view");
            }
            if ($(groupRow).find(".permission-checkbox-2").is(":checked")) {
                permissions[id].push("install:" + installId + ":delete", "install:" + installId + ":modify");
            }
            if ($(groupRow).find(".permission-checkbox-3").is(":checked")) {
                permissions[id].push(
                    "install:" + installId + ":sc:view",
                    "install:" + installId + ":cc:view",
                    "install:" + installId + ":layout:view"
                );
            }
            if ($(groupRow).find(".permission-checkbox-4").is(":checked")) {
                permissions[id].push(
                    "install:" + installId + ":sc:modify",
                    "install:" + installId + ":cc:modify",
                    "install:" + installId + ":modify",
                    "install:" + installId + ":layout:create",
                    "install:" + installId + ":layout:modify",
                    "install:" + installId + ":layout:delete"
                );
            }
            permissions[id] = _.uniq(permissions[id]);
        });
        _.each(this.$('.permissions-loaded .permission-row[data-permission="control"]'), (groupRow) => {
            var id = $(groupRow).attr("data-id");
            if (!_.has(permissions, id)) permissions[id] = [];

            if ($(groupRow).find(".permission-checkbox-1").is(":checked")) {
                permissions[id].push("install:" + installId + ":ctrl:view");
            }
            if ($(groupRow).find(".permission-checkbox-2").is(":checked")) {
                permissions[id].push("install:" + installId + ":ctrl:modify", "install:" + installId + ":modify");
            }
            if ($(groupRow).find(".permission-checkbox-3").is(":checked")) {
                permissions[id].push("install:" + installId + ":ovrd:view");
            }
            if ($(groupRow).find(".permission-checkbox-4").is(":checked")) {
                permissions[id].push("install:" + installId + ":ovrd:modify");
            }
            permissions[id] = _.uniq(permissions[id]);
        });

        return permissions;
    }

    handleAddInstallButtonClick() {
        this.setFormSubmitted();
        console.log(this.getPermissionsDict());
        var installId = this.getInstallId();
        var orgId = this.getOrgId();
        $.ajax({
            type: "POST",
            url: this.options.installCollection.url(),
            data: JSON.stringify({
                organizationId: orgId,
                installId: installId,
                name: this.getName(),
                permissions: this.getPermissionsDict(),
            }),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: () => {
                this.refetchCollectionsAndShowDashboard(orgId, installId);
            },
        });
    }

    refetchCollectionsAndShowDashboard(orgId, installId) {
        var d1 = this.options.installCollection.fetch({ reset: true });
        var d2 = this.options.permissionCollection.fetch({ reset: true });

        $.when(d1, d2)
            .done(() => {
                window.location.hash = "#/status/" + orgId + "/" + installId;
                this.hide();

                window['App'].Bus.trigger('navigation:update');
            })
            .fail(() => {
                this.setFormError();
            });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/AddInstallModal.ts